<template>
  <button v-if="buttonStyle == 0" type="button" class="btn btn-primary" @click="showModal()"><font-awesome-icon icon="plus" /> Erstellen</button>

  <button v-else type="button" class="btn btn-primary btn-sm" title="Benutzer bearbeiten" @click="showModal()">
    <font-awesome-icon icon="pen" />
  </button>

  <!-- Edit Benutzer Modal -->
  <div
    class="modal fade text-start"
    :id="'editBenutzerModal' + index"
    tabindex="-1"
    :aria-labelledby="'editBenutzerModal' + index"
    aria-hidden="true"
    ref="editBenutzerModalRef"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary py-2">
          <span v-if="editBenutzer.id == 0" class="modal-title my-auto" :id="'editBenutzerModalLabel' + index"> Neuer Benutzer </span>

          <span v-else class="modal-title my-auto" :id="'editBenutzerModalLabel' + index"> Benutzer bearbeiten </span>

          <button type="button" class="btn-close btn-sm text-white" @click="closeModal()"></button>
        </div>

        <div class="modal-body" :id="'editBenutzerModalBody' + index">
          <LoadingSpinner v-if="loading" />

          <div class="mb-3">
            <label for="set-benutzer-email" class="form-label fw-bold">Name</label>
            <input type="text" class="form-control" id="set-benutzer-email" v-model="editBenutzer.name" />
          </div>

          <div class="mb-4">
            <label :for="'set-benutzer-rolle-' + index" class="form-label fw-bold">Benutzerrolle</label>

            <select class="form-select" :id="'set-benutzer-rolle-' + index" aria-label="Benutzerrolle auswählen" v-model="editBenutzer.isAdmin">
              <option :value="false">Benutzer</option>
              <option :value="true">Admin</option>
            </select>
          </div>

          <div class="form-check mb-4">
            <input class="form-check-input" type="checkbox" :id="'set-can-sign-' + index" v-model="editBenutzer.canSign" />
            <label class="form-check-label" :for="'set-can-sign-' + index"> Kann Verträge unterschreiben </label>
          </div>

          <div v-if="editBenutzer.id == 0" class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <p class="fw-bold mb-0 flex-fill">Archiv Benutzer auswählen</p>

              <div class="input-group input-group-sm w-50">
                <input v-model.trim="searchString" type="search" class="form-control" id="searchInput" placeholder="Suche..." />
                <span class="input-group-text">
                  <font-awesome-icon icon="magnifying-glass" class="p-1" />
                </span>
              </div>
            </div>

            <div v-if="selectedBenutzerExists" class="alert alert-danger my-4">
              Der Benutzer exisitiert bereits. Bitte wählen Sie einen anderen Archiv-Benutzer aus.
            </div>

            <div v-if="errorMsg != ''" class="alert alert-danger my-4">
              <strong class="text-danger">Es ist ein Fehler aufgetreten: </strong> {{ errorMsg }}.
            </div>

            <div class="row mx-0 mb-2 bg-white shadow-sm">
              <div class="col py-2 table-col">
                <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <strong class="me-1">Benutzer</strong>

                  <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'benutzernameasc'" class="text-secondary table-sort-icon" />
                  <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'benutzernamedesc'" class="text-secondary table-sort-icon" />

                  <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                    <li class="dropdown-item select-sort" @click="sortBy('benutzernameasc')">
                      <div class="row">
                        <div class="col-2">
                          <font-awesome-icon icon="check" v-show="sortByValue == 'benutzernameasc'" />
                        </div>
                        <div class="col">A - Z</div>
                      </div>
                    </li>
                    <li class="dropdown-item select-sort" @click="sortBy('benutzernamedesc')">
                      <div class="row">
                        <div class="col-2">
                          <font-awesome-icon icon="check" v-show="sortByValue == 'benutzernamedesc'" />
                        </div>
                        <div class="col">Z - A</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col py-2 table-col">
                <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <strong class="me-1">Username</strong>

                  <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'usernameasc'" class="text-secondary table-sort-icon" />
                  <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'usernamedesc'" class="text-secondary table-sort-icon" />

                  <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                    <li class="dropdown-item select-sort" @click="sortBy('usernameasc')">
                      <div class="row">
                        <div class="col-2">
                          <font-awesome-icon icon="check" v-show="sortByValue == 'usernameasc'" />
                        </div>
                        <div class="col">A - Z</div>
                      </div>
                    </li>
                    <li class="dropdown-item select-sort" @click="sortBy('usernamedesc')">
                      <div class="row">
                        <div class="col-2">
                          <font-awesome-icon icon="check" v-show="sortByValue == 'usernamedesc'" />
                        </div>
                        <div class="col">Z - A</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col py-2 table-col">
                <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <strong class="me-1">E-Mail</strong>

                  <font-awesome-icon icon="arrow-down-long" v-show="sortByValue == 'emailasc'" class="text-secondary table-sort-icon" />
                  <font-awesome-icon icon="arrow-up-long" v-show="sortByValue == 'emaildesc'" class="text-secondary table-sort-icon" />

                  <ul class="dropdown-menu m-0 ms-1 p-0 rounded-0">
                    <li class="dropdown-item select-sort" @click="sortBy('emailasc')">
                      <div class="row">
                        <div class="col-2">
                          <font-awesome-icon icon="check" v-show="sortByValue == 'emailasc'" />
                        </div>
                        <div class="col">A - Z</div>
                      </div>
                    </li>
                    <li class="dropdown-item select-sort" @click="sortBy('emaildesc')">
                      <div class="row">
                        <div class="col-2">
                          <font-awesome-icon icon="check" v-show="sortByValue == 'emaildesc'" />
                        </div>
                        <div class="col">Z - A</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="users-section">
              <div v-for="user in sortedBenutzer" :key="user.id">
                <ArchivUserRow :user="user" @click="setIdentityUser(user)" :edit-benutzer="editBenutzer" :benutzer="benutzer" />
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer justify-content-between">
          <button v-if="!loading && editBenutzer.id != 0" type="button" class="btn btn-danger" @click="deleteBenutzer()">
            <font-awesome-icon icon="trash" /> Benutzer löschen
          </button>
          <div v-else></div>

          <div>
            <button type="button" class="btn btn-secondary me-3" @click="closeModal()">Abbrechen</button>
            <button type="button" class="btn btn-primary" @click="saveBenutzer()" :disabled="selectedBenutzerExists">Speichern</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import { Modal } from 'bootstrap';

  import { ActionTypes as AuthActionTypes } from '@/store/modules/Auth/actions';

  import LoadingSpinner from '../LoadingSpinner.vue';
  import ArchivUserRow from './ArchivUserRow.vue';

  import { Benutzer, ArchivUser } from '../../models/AuthModels';
  //Endregion

  const props = defineProps({
    benutzer: {
      type: Object as PropType<Benutzer>,
      default: new Benutzer(),
    },

    index: {
      type: Number,
      required: true,
    },

    buttonStyle: {
      type: Number as PropType<number>,
      default: 0, // 0 = erstellen; 1 = bearbeiten
    },
  });

  const emit = defineEmits(['deleteBenutzer']);

  const store = useStore();

  const loading = computed(() => store.getters.status.createBenutzerLoading || store.getters.status.updateBenutzerLoading);
  const errorMsg = computed(() => store.getters.status.benutzerErrorMsg);

  const archivUsers = computed(() => store.getters.archivUsers);
  const benutzer = computed(() => store.getters.benutzer);

  //#region Sortierung
  const searchString = ref('');

  const sortByValue = ref('benutzernameasc');
  function sortBy(param: string) {
    sortByValue.value = param;
  }

  const sortedBenutzer = computed(() => {
    return archivUsers.value
      .filter((v: ArchivUser) => {
        return (
          v?.benutzername?.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v?.username?.trim().toLowerCase().includes(searchString.value.trim().toLowerCase()) ||
          v?.email?.trim().toLowerCase().includes(searchString.value.trim().toLowerCase())
        );
      })
      .sort((a: ArchivUser, b: ArchivUser) => {
        if (sortByValue.value == 'benutzernamedesc' || sortByValue.value == 'benutzernameasc') {
          var benutzernameComparison =
            a?.benutzername
              ?.trim()
              .toLowerCase()
              .localeCompare(b?.benutzername?.trim().toLowerCase() || '') || 0;
          if (sortByValue.value == 'benutzernamedesc') {
            benutzernameComparison = -1 * benutzernameComparison;
          }

          return benutzernameComparison;
        }

        if (sortByValue.value == 'usernameasc' || sortByValue.value == 'usernamedesc') {
          var usernameComparison =
            a?.username
              ?.trim()
              .toLowerCase()
              .localeCompare(b?.username?.trim().toLowerCase() || '') || 0;
          if (sortByValue.value == 'usernamedesc') {
            usernameComparison = -1 * usernameComparison;
          }

          return usernameComparison;
        }

        if (sortByValue.value == 'emailasc' || sortByValue.value == 'emaildesc') {
          var emailComparison =
            a?.email
              ?.trim()
              .toLowerCase()
              .localeCompare(b?.email?.trim().toLowerCase() || '') || 0;
          if (sortByValue.value == 'emaildesc') {
            emailComparison = -1 * emailComparison;
          }

          return emailComparison;
        }

        return 0;
      });
  });
  //#endregion

  const editBenutzer = ref(new Benutzer());

  function setIdentityUser(user: ArchivUser) {
    if (editBenutzer.value.identityUserId == user.id) {
      editBenutzer.value.identityUserId = 0; // Deselect user
    } else {
      editBenutzer.value.identityUserId = user.id;
    }
  }

  const selectedBenutzerExists = computed(() => {
    return editBenutzer.value.id == 0 && benutzer.value.some((b: Benutzer) => b.identityUserId === editBenutzer.value.identityUserId);
  });

  function saveBenutzer() {
    if (editBenutzer.value.id != 0) {
      store.dispatch(AuthActionTypes.UpdateBenutzer, editBenutzer.value).then(() => {
        if (errorMsg.value == '') {
          closeModal();
        }
      });
    } else {
      store.dispatch(AuthActionTypes.CreateBenutzer, editBenutzer.value).then(() => {
        if (errorMsg.value == '') {
          closeModal();
        }
      });
    }
  }

  function deleteBenutzer() {
    closeModal();
    emit('deleteBenutzer', props.benutzer.id);
    // store.dispatch(AuthActionTypes.DeleteBenutzer, props.benutzer.id);
  }

  //#region Modal
  const editBenutzerModalRef = ref();

  function closeModal() {
    Modal.getInstance(editBenutzerModalRef.value)?.hide();
  }

  function showModal() {
    if (editBenutzerModalRef.value) {
      editBenutzer.value = JSON.parse(JSON.stringify(props.benutzer)) as Benutzer;
      new Modal(editBenutzerModalRef.value).show();
    }
  }
  //#endregion
</script>

<style scoped>
  .modal-content {
    background: rgb(242, 243, 248);
  }

  .users-section {
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
  }

  /* .modal-body {
  background: rgb(242, 243, 248);
}

.modal-footer {
  background: rgb(242, 243, 248);
} */

  .table-col:hover {
    background: rgb(216, 217, 222);
    cursor: pointer;
  }

  .table-sort-icon {
    font-size: 0.7em;
  }

  .select-sort:hover {
    cursor: pointer;
  }
</style>
